<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                                   <b-row>
                                         <b-col lg="6" sm="12">
                                           <ValidationProvider name="Organization Name" vid="org_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="6"
                                                    label-for="org_id "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('institute_manangement.organization_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="case_mapp.org_id"
                                                    id="org_id"
                                                    :options="orgList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                         </b-col>
                                         <b-col lg="6" sm="12">
                                             <ValidationProvider name="Institute Type" vid="office_type_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="6"
                                                        label-for="office_type_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('child_configuration.institute_type')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="case_mapp.office_type_id"
                                                        :options="officeTypeList"
                                                        id="office_type_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col lg="6" sm="12">
                                           <ValidationProvider name="Institute Name" vid="office_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="6"
                                                    label-for="office_id "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('institute_manangement.institute_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="case_mapp.office_id"
                                                    id="office_id"
                                                    :options="officeList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                         <b-col lg="6" sm="12">
                                          <ValidationProvider name="Date" vid="complain_date" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="6"
                                                    label-for="complain_date"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('globalTrans.date')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                    class="date-picker"
                                                    v-model="case_mapp.complain_date"
                                                    :placeholder="$t('globalTrans.date')"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-overlay :show="unitLoad">
                                    <b-row>
                                       <b-col lg="6" sm="12">
                                            <ValidationProvider name="Registration ID" vid='registration_id' rules="required">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="6"
                                                label-for="registration_id"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('institute_manangement.registration_id')}}  <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                id="registration_id"
                                                v-model="case_mapp.registration_id"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                         </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12" v-if="currentLocale === 'en'">
                                            <ValidationProvider name="name" vid='name'>
                                             <b-form-group
                                                    class="row"
                                                    label-cols-sm="6"
                                                    label-for="name "
                                                    >
                                                    <template                                         te v-slot:label>
                                                    {{$t('globalTrans.name')}}
                                                    </template>
                                                    <b-form-input readonly
                                                    plain
                                                    v-model="case_mapp.online_admission_name"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                             </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12" v-else>
                                            <ValidationProvider name="name" vid='name'>
                                               <b-form-group
                                                    class="row"
                                                    label-cols-sm="6"
                                                    label-for="name"
                                                    >
                                                    <template                                         te v-slot:label>
                                                    {{$t('globalTrans.name')}}
                                                    </template>
                                                    <b-form-input readonly
                                                    plain
                                                    v-model="case_mapp.online_admission_name_bn"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                             </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    </b-overlay>
                                    <b-row>
                                    <b-col lg="12" sm="12">
                                        <ValidationProvider name="Complain Details(En)" vid='complain_details_en'>
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="3"
                                                label-for="complain_details_en"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('institute_manangement.complain_details_en')}}
                                                </template>
                                                <b-form-textarea
                                                id="complain_details_en"
                                                v-model="case_mapp.complain_details_en"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                 rows="2"
                                                max-rows="6"
                                                ></b-form-textarea>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                         <ValidationProvider name="Complain Details (Bn)" vid='complain_details_bn'>
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="3"
                                                label-for="complain_details_bn"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('institute_manangement.complain_details_bn')}}
                                                </template>
                                                <b-form-textarea
                                                id="complain_details_bn"
                                                v-model="case_mapp.complain_details_bn"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                 rows="2"
                                                max-rows="6"
                                                ></b-form-textarea>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                    <div class="row">
                                        <div class="col-sm-3"></div>
                                        <div class="col text-right">
                                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            &nbsp;
                                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                        </div>
                                        </div>
                                </b-form>
                            </ValidationObserver>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { getResidentDetailApi, complainFeedbkStoreApi, committeemanagementUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
    if (this.id) {
      const tmp = this.getcategoryData()
      // Object.freeze(tmp)
      this.case_mapp = tmp
    }
        this.case_mapp.org_id = this.$store.state.dataFilters.orgId
        this.case_mapp.office_type_id = this.$store.state.dataFilters.officeTypeId
        this.case_mapp.office_id = this.$store.state.dataFilters.officeId
  },
    mounted () {
        flatpickr('.date-picker', {})
        core.index()
    },
    data () {
        return {
            ItemShow: false,
           saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            case_mapp: {
                org_id: 0,
                office_type_id: 0,
                office_id: 0,
                registration_id: '',
                online_admission_name: '',
                complain_date: '',
                complain_details_en: '',
                complain_details_bn: ''
            },
            officeTypeList: [],
            officeList: [],
            unitLoad: false
        }
    },
    computed: {
     orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        currentLocale () {
            return this.$i18n.locale
        },
        ...mapGetters({
            childCommonObj: 'ChildService/commonObj'
        })
  },
    watch: {
         'case_mapp.org_id': function (newVal, oldVal) {
         this.getOfficeTypeList()
         },
         'case_mapp.office_type_id': function (newVal, oldVal) {
          this.getOfficeList()
         },
          'case_mapp.registration_id': function (newVal, oldVal) {
            if (oldVal !== newVal) {
                if (newVal.length === 11) {
                    this.getResident(newVal)
                }
            }
        },
         currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.case_mapp.org_id) {
                this.getOfficeTypeList()
            }
            if (this.case_mapp.office_type_id) {
                this.getOfficeList()
            }
        }
    }
    },
    methods: {
         getcategoryData () {
        const tmpData = this.$store.state.list.find(item => item.id === this.id)
        return JSON.parse(JSON.stringify(tmpData))
    },
       getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.case_mapp.org_id && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value)).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.case_mapp.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getResident ($regId) {
        this.unitLoad = true
            RestApi.getData(childServiceBaseUrl, getResidentDetailApi + '/' + $regId).then(response => {
                if (response.success === true) {
                    this.case_mapp.online_admission_name = response.data.name
                    this.case_mapp.online_admission_name_bn = response.data.name_bn
                    this.unitLoad = false
                } else {
                    this.$toast.error({
                        title: this.$t('globalTrans.error'),
                        message: this.$t('institute_manangement.no_resident'),
                        color: '#D6E09B'
                    })
                    this.case_mapp.online_admission_name = ''
                    this.case_mapp.online_admission_name_bn = ''
                    this.case_mapp.registration_id = ''
                    this.unitLoad = false
                }
            })
        },
    async saveData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadingState = { loading: false, listReload: false }
            if (this.id) {
                result = await RestApi.putData(childServiceBaseUrl, `${committeemanagementUpdateApi}/${this.id}`, this.case_mapp)
            } else {
                result = await RestApi.postData(childServiceBaseUrl, complainFeedbkStoreApi, this.case_mapp)
            }
            loadingState.listReload = true
            this.$store.dispatch('mutateCommonProperties', loadingState)
            if (result.success) {
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else {
                this.$refs.form.setErrors(result.errors)
            }
        }
    }
}

</script>
